import { render } from "storyblok-rich-text-react-renderer";
import RichText from "@/components/RichText/RichText";
import BlogRichText from "@/components/Blog/BlogRichText/BlogRichText";

const BlogRichTextWithProps = ({ blok }) => {
  return <BlogRichText content={blok.content} />;
};

export default BlogRichTextWithProps;
